import { Box } from '@mui/material'
import type { Theme } from '@mui/material'

// Link blue: readable on both themes (primary.main is white in dark mode).
export const newMarkerColor = (theme: Theme) =>
  theme.palette.mode === 'dark' ? '#58A6FF' : '#0969DA'

/** Small dot that marks something new, e.g. unseen changelog entries. */
const NewDot = () => (
  <Box
    component="span"
    aria-hidden
    sx={{
      display: 'inline-block',
      width: 6,
      height: 6,
      ml: 0.75,
      borderRadius: '50%',
      backgroundColor: newMarkerColor,
      verticalAlign: 'middle',
    }}
  />
)

export default NewDot
